/**
* DevExpress HTML/JS Reporting (viewer\parameters\previewParametersViewModel.viewmodel.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { createViewModelGenerator } from '@devexpress/analytics-core/analytics-serializer-native';
import { getLocalization } from '@devexpress/analytics-core/analytics-internal-native';
export function createPreviewParametersViewModel(baseModel) {
    return createViewModelGenerator(baseModel)
        .generateProperty('headerText', getLocalization('Preview Parameters', 'ASPxReportsStringId.ReportDesigner_Preview_ParametersTitle'))
        .generateProperty('showHeader', this._showHeader)
        .generateProperty('emptyText', getLocalization('The report does not contain any parameters.', 'ASPxReportsStringId.WebDocumentViewer_NoParameters'))
        .generateProperty('isEmpty', this.isEmpty)
        .generateProperty('buttons', this.buttons)
        .generateProperty('showButtons', this.showButtons)
        .generateProperty('parametersLoading', this.parametersLoading)
        .getViewModel();
}
export function updateViewModel(args) {
    const viewModel = this.getViewModel();
    viewModel.isEmpty = this.isEmpty;
    viewModel.parametersLoading = this.parametersLoading;
    viewModel.showHeader = this._showHeader;
    viewModel.showButtons = this.showButtons;
    if (args.propertyName === 'buttons') {
        viewModel.buttons = [].concat(this.buttons);
    }
}
